import React, { Component } from 'react';
import Button                     from '../../../components/Button'

class Main extends Component {

  navListUsers() {
    this.props.history.push('/dashboard/list-users');
  }

  navAddMember() {
    this.props.history.push('/dashboard/add-member');
  }

  render() {
    return (
      <div className="main">
        <div className="home-content">
          <h3>What would you like to do?</h3>
        </div>
        <div className= "nav-area">
          <Button className="add-member-button" onClick={this.navAddMember.bind(this)}> Register Member </Button>
          <Button className="search-member-button" onClick={e => {this.props.history.push('/dashboard/search-member')}}> Search Member </Button>
        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Main/Main.js